import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/Layout/Layout";

import HomeHero from "../components/sections/HomePage/HomeHero/HomeHero";
import HomeWhat from "../components/sections/HomePage/HomeWhat/HomeWhat";
import HomeSteps from "../components/sections/HomePage/HomeSteps/HomeSteps";
import HomeWhy from "../components/sections/HomePage/HomeWhy/HomeWhy";
import HomeRegister from "../components/sections/HomePage/HomeRegister/HomeRegister";

const IndexPage = ({ data }) => {
  return (
    <Layout>
      <HomeHero title={data.sanityHomePage.heroText} />
      <HomeWhat />
      <HomeSteps steps={data.sanityHomePage.steps} />
      <HomeWhy />
      <HomeRegister />
    </Layout>
  );
};

export const query = graphql`
  query HomePageQuery($siteVariant: String) {
    sanityHomePage(title: { eq: $siteVariant }) {
      title
      steps
      heroText
    }
  }
`;

export default IndexPage;
